/**
 * Sysadmin Runtime — TanStack Query hooks (Wave 3 §10.2 #6).
 *
 * Wraps GET /api/v1/admin/platform/runtime/services with a 10-second
 * polling interval — matches the cadence of the existing
 * useRuntimeHardware() hook for the Models > Runtime panel so the
 * sysadmin's two operational-ops surfaces refresh at the same rate.
 */

import { useQuery } from '@tanstack/react-query';
import { apiClient } from './api-client';

export type ServiceStatus = 'healthy' | 'degraded' | 'down' | 'unknown';

export interface ServiceHealthRow {
  name: string;
  status: ServiceStatus;
  latencyMs: number | null;
  lastProbedAt: string | null;
  version: string | null;
  errorMessage: string | null;
}

export interface ServiceHealthResponse {
  services: ServiceHealthRow[];
  collectedAt: string;
}

export function useSysadminServices() {
  return useQuery<ServiceHealthResponse, Error>({
    queryKey: ['sysadmin-runtime-services'],
    queryFn: () =>
      apiClient.get<ServiceHealthResponse>('/admin/platform/runtime/services'),
    refetchInterval: 10_000,
    refetchIntervalInBackground: false,
  });
}
